import React from 'react';
import {
  FreeZoneColumnSection,
  BoxOne,
  BoxField,
  ArticleContent,
  BoxTwo,
} from './styles/FreeZoneTwoColumn.styled';

export default function TwoColumnsText({ data, id }) {
  return (
    <FreeZoneColumnSection id={id}>
      <BoxOne>
        <BoxField>
          <ArticleContent>
            <h2>{data.column1Title}</h2>
            {data.column1Paragraphs.map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </ArticleContent>
        </BoxField>
      </BoxOne>
      <BoxTwo>
        <ArticleContent>
          <h2>{data.column2Title}</h2>
          {data.column2Paragraphs.map((text, index) => (
            <p key={index}>{text}</p>
          ))}
        </ArticleContent>
      </BoxTwo>
    </FreeZoneColumnSection>
  );
}
